import type { QueryOptionsOverride } from '../queryOptions.helpers';
import type { PlayerDto } from './player.schema';
import {
  queryOptions,
} from '@tanstack/react-query';
import { QueriesKeys } from '../queriesKeys';
import { playerApi } from './player.api';
import { applyPendingPlayerProgress, mergePlayerQueryData } from './player.sync';

export const playerQueryOptions = {
  /**
   * Fetch the profile of the current player.
   */
  mePlayerProfile: (options?: QueryOptionsOverride<PlayerDto>) => queryOptions({
    queryKey: [QueriesKeys.mePlayerProfile],
    queryFn: async ({ client }) => applyPendingPlayerProgress(client, await playerApi.getMePlayerProfile()),
    structuralSharing: (previous, incoming) => mergePlayerQueryData(
      previous as PlayerDto | undefined,
      incoming as PlayerDto,
    ),
    ...options,
  }),

};
